<template>
  <form @submit.prevent="save_event" class="mt-8">

    <memlist-text-input
      id="input-event_id"
      name="event_id"
      :title="'ID'"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.event_id"
      disabled
    />

    <memlist-text-input
      id="input-name"
      name="name"
      :title="$t('EVENT.EVENT_NAME')"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.name"
      required
      @input="on_change"
    />

    <label class="mt-4 mb-2 d-block bold">{{$t('EVENT.DESCRIPTION')}}</label>
    <memlist-tiptap 
      v-model="local_item.descr_html" 
      @input="on_change"
    />


    <memlist-datetime-picker
      class="mt-8"
      :label="$t('EVENT.START_TIME')"
      v-model="local_item.from_datetime"
      @input="on_change"
    />
    <memlist-datetime-picker
      class="mt-8"
      :label="$t('EVENT.END_TIME')"
      v-model="local_item.to_datetime"
      @input="on_change"
    />

    <memlist-checkbox
      class="mt-6"
      :text="$t('EVENT.DEADLINE_DATETIME')"
      v-model="local_item.use_deadline"
      @input="on_change"
    />

    <memlist-datetime-picker
      v-if="local_item.use_deadline"
      class="mt-8"
      :label="$t('EVENT.DEADLINE_DATETIME_DATE')"
      v-model="local_item.deadline_datetime"
      @input="on_change"
    />

  </form>
</template>

<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';


export default {
  props: ['item'],
  mixins: [ toasts ],
  
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        console.log('watch changed')
        this.local_item = JSON.parse(JSON.stringify(this.item));
      },
      immediate: true
    },

  },
  methods: {
    save_event() {},
    on_change() {
      console.log('form has changed', this.local_item)
      this.$emit('change', this.local_item);
    }
  },
  data() {
    return {
      local_item: {}
    }
  },
}
</script>
